"use client";
import { useSearchParams } from "next/navigation";
import { useState } from "react";
import {
  useOtpLogin,
  useSendVerificationCode,
} from "@/api/AppApi/services/auth";
import { ApiMsgTypes } from "@/api/AppApi/common-interfaces/IResultStamp";
import { useAtom } from "jotai";
import { isSignedInAtom } from "@/hooks/authAtoms";
import CodeForm, { resendPeriod } from "../auth-common/confirmation/CodeForm";
import { storeAuthTokens } from "@/utils/functions/cookieOperations";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { IGTagUserData } from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/helpers/interfaces";
import useEventTrackers from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/useEventTrackers";

export const otpLoginQuery = (username: string) => {
  return `${PagesPaths.otp_signin}?username=${username}`;
};

const OtpSignIn = () => {
  const [counter, setCounter] = useState(resendPeriod);
  const [code, setCode] = useState("");
  const [isError, setIsError] = useState(false);
  const [, setSignedIn] = useAtom(isSignedInAtom);
  const { userLoginEventTracher } = useEventTrackers();
  const t = useTranslation();
  const router = useRouter();
  const searchParams = useSearchParams();
  //=============
  const usernameData = searchParams?.get("username") as string;
  const byEmail = usernameData.includes("@");
  const username = byEmail ? usernameData : JSON.parse(usernameData);
  // ========================
  const sendVerificationCode = useSendVerificationCode({
    onSuccess: (res) => {
      setCounter(resendPeriod);
      if (res?.message?.type === ApiMsgTypes.success) {
      }
    },
    onError: (_err) => {
      setCounter(resendPeriod);
    },
  });
  const verifyPost = useOtpLogin({
    onSuccess: (res) => {
      const { user } = res?.result ?? {};
      if (res?.message?.type === ApiMsgTypes.success) {
        setCounter(0);
        storeAuthTokens(res.result?.access_token!, res.result?.refresh_token!);
        setSignedIn(true);
        const userData: IGTagUserData = {
          user_id: user?.id,
          name: user?.name,
          email: user?.email,
          phone: user?.mobile,
        };
        userLoginEventTracher(true, { ...userData });
        router.replace(`/`);
      }
    },
    onError: (error) => {
      if (error.response?.status === 400) {
        setIsError(true);
      } else setIsError(true);
    },
  });
  const sendCode = () => {
    sendVerificationCode.mutate({
      username: username,
    });
  };
  const verifyCode = () => {
    setIsError(false);
    verifyPost.mutate({
      username: username,
      token: code,
    });
  };

  const title = byEmail ? t.check_your_email : t.check_your_mobile;
  const subtitle = byEmail
    ? t.enter_email_verification_code
    : t.enter_phone_verification_code;
  const isLoading = sendVerificationCode.isLoading || verifyPost.isLoading;
  return (
    <CodeForm
      title={title}
      subtitle={subtitle}
      setCode={setCode}
      sendCode={sendCode}
      verifyCode={verifyCode}
      byEmail={byEmail}
      isLoading={isLoading}
      counter={counter}
      setCounter={setCounter}
      isError={isError}
    />
  );
};

export default OtpSignIn;
